<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50" (click)="fecharModal()"></div>

  <div class="relative flex flex-col gap-4 p-6 bg-white rounded-lg w-full max-w-2xl max-h-screen overflow-y-auto">
    <button
      class="absolute top-4 right-4 w-10 h-8 rounded-sm btn--secondary"
      type="button"
      title="Fechar"
      (click)="fecharModal()"
    >
      X
    </button>

    <h2 class="font-black uppercase text-chathams-blue">Detalhes do Colaborador</h2>

    <div *ngIf="carregando" class="py-8 text-center text-chathams-blue">Carregando...</div>

    <div *ngIf="!carregando && erro" class="py-8 text-center text-cerise-red">
      {{ erro }}
    </div>

    <div *ngIf="!carregando && !erro && employee" class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">Nome</label>
        <span
          class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all"
          >{{ employee.name }}</span
        >
      </div>
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">Empresa</label>
        <span class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all">
          {{ employee.subsidiary?.company?.name || '-' }}
        </span>
      </div>
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">Função</label>
        <span class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all">
          {{ employee.role || '-' }}
        </span>
      </div>
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">Matrícula</label>
        <span class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all">
          {{ employee.registrationNumber || '-' }}
        </span>
      </div>
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">E-mail</label>
        <span class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all">
          {{ employee.email || '-' }}
        </span>
      </div>
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">Telefone</label>
        <span class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all">
          {{ employee.phone || '-' }}
        </span>
      </div>
      <div class="flex flex-col">
        <label class="text-sm text-gray-600">Situação</label>
        <span class="border border-gray-400 min-h-[2.25rem] rounded-sm flex items-center px-3 py-1 font-bold break-all">
          {{ statusInfo(employee.status)?.label ?? 'Não informada' }}
        </span>
      </div>
    </div>

    <div *ngIf="!carregando && !erro && !employee" class="py-8 text-center text-chathams-blue">
      Nenhum detalhe encontrado.
    </div>
  </div>
</div>
